module.exports = __webpack_public_path__ + "static/img/iso27001.aa407ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/iso27001.png
// module id = zKlO
// module chunks = 0